function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import {
    Picker,
    MultiPicker,
    Slider,
    Slider_vertical,
    Switch
} from './components/components';
import utils from './utils';
import Thumbnails from './thumbnails';
var Controller = function () {
    function Controller(player) {
        var _this = this;
        _classCallCheck(this, Controller);
        var THIS = this;
        this.player = player;
        this.template = player.template;
        this.components = player.components;
        this.video = player.video;
        this.autoHideTimer = null;
        this.volumeHideTimer = null;
        this.isSetVolume = false;
        this.isControl = false;
        this.controlLeaved = false;
        this.clickFlag = 0;
        this.controllTimer = null;
        this.danmakuFontsize = '25';
        this.danmakuType = 'right';
        this.danmakuColor = '#FFFFFF';
        this.videoScale = false;
        this.mask = document.createElement('div');
        this.mask.classList.add('heimu');
        this.player.template.videoWrap.addEventListener('mousemove', function () {
            _this.setAutoHide();
        });
        this.player.template.controller.addEventListener('click', function (event) {
            window.event ? window.event.cancelBubble = true : event.stopPropagation();
        });
        this.isControllerfocus();
        this.checkLogin(player);
        this.initPlayButton();
        this.initActivity();
        this.initThumbnails();
        if (player.options.draggable) {
            this.initPlayedBar();
            this.initTimeLabel();
        }
        if (player.options.danmaku) {
            this.initDanmakuButton();
            this.initDanmakuStyleButton();
            this.initDanmakuEmit();
        }
        if (player.options.video.length > 1) {
            this.initPagelistButton();
        }
        if (player.options.widescreenSwitch) {
            this.initWidescreenButton();
        }
        this.watchPlayerScroll = function (e) {
            if (_this.template.container.getBoundingClientRect().top + _this.template.container.offsetHeight <= 0) {
                if (_this.template.miniPlayer.classList.contains('hide')) {
                    _this.template.miniPlayer.classList.remove('hide');
                    var content = _this.template.miniPlayer.querySelector('.content');
                    _this.template.previewMask.removeChild(_this.template.videoMask);
                    _this.template.previewMask.removeChild(_this.template.danmaku);
                    content.appendChild(_this.template.videoMask);
                    content.appendChild(_this.template.danmaku);
                    content.onclick = function () {
                        _this.player.toggle();
                    };
                    if (_this.player.danmaku) {
                        _this.player.danmaku.mini(true);
                        _this.player.danmaku.resize();
                        _this.player.danmaku.seek();
                    }
                }
            } else {
                if (!_this.template.miniPlayer.classList.contains('hide')) {
                    _this.template.miniPlayer.classList.add('hide');
                    var _content = _this.template.miniPlayer.querySelector('.content');
                    _content.removeChild(_this.template.videoMask);
                    _content.removeChild(_this.template.danmaku);
                    _this.template.previewMask.appendChild(_this.template.videoMask);
                    _this.template.previewMask.appendChild(_this.template.danmaku);
                    if (_this.player.danmaku) {
                        _this.player.danmaku.mini(false);
                        _this.player.danmaku.resize();
                        _this.player.danmaku.seek();
                    }
                }
            }
        };
        this.initRepeatButton();
        this.initVolumeButton();
        this.initFullButton();
        this.initPictureInPicture();
        this.initSpeedButton();
        this.initSettingsButton();
    }
    _createClass(Controller, [
        {
            key: 'isControllerfocus',
            value: function isControllerfocus() {
                var _this2 = this;
                this.template.controller.onmouseenter = function () {
                    _this2.isControl = true;
                    _this2.controlLeaved = false;
                };
                this.template.controller.onmouseleave = function () {
                    _this2.isControl = false;
                    _this2.controlLeaved = true;
                };
            }
        },
        {
            key: 'checkLogin',
            value: function checkLogin(player) {
                var _this3 = this;
                if (player.options.uid === undefined && player.options.danmaku) {
                    player.template.toLogin.addEventListener('click', function () {
                        player.fullScreen.isFullScreen('browser') && player.fullScreen.cancel('browser');
                        player.fullScreen.isFullScreen('web') && player.fullScreen.cancel('web');
                        _this3.isControl = false;
                        _this3.player.events && _this3.player.events.trigger('toLogin');
                    });
                }
            }
        },
        {
            key: 'initActivity',
            value: function initActivity() {
                var _this4 = this;
                this.switchActivity();
                this.template.activity.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var activity = _this4.player.options.activity;
                    window.open(activity[_this4.currentActivity].link);
                });
                this.template.activityClose.addEventListener('click', function (e) {
                    e.stopPropagation();
                    _this4.template.activityMask.classList.remove('show');
                    _this4.noActivity = true;
                });
            }
        },
        {
            key: 'switchActivity',
            value: function switchActivity() {
                var activity = this.player.options.activity;
                if (activity.length) {
                    this.currentActivity = Math.round(Math.random() * (activity.length - 1));
                    this.template.activity.style.backgroundImage = 'url('.concat(activity[this.currentActivity].pic, ')');
                }
            }
        },
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this5 = this;
                this.template.videoWrap.addEventListener('click', function () {
                    return _this5.handleClick();
                });
                this.template.play_btn.addEventListener('click', function () {
                    return _this5.player.toggle();
                });
            }
        },
        {
            key: 'handleClick',
            value: function handleClick() {
                if (!this.isControl && !this.player.isShowMenu && this.player.videoLoaded) {
                    this.player.toggle();
                } else {
                    this.player.isShowMenu = false;
                }
            }
        },
        {
            key: 'initThumbnails',
            value: function initThumbnails() {
                var _this6 = this;
                this.thumbnails = new Thumbnails({
                    container: this.player.template.barPreview,
                    barWidth: this.player.template.barWrap.offsetWidth,
                    url: this.player.options.video[this.player.currentVideo].thumbnails,
                    events: this.player.events
                });
                this.player.on('loadedmetadata', function () {
                    _this6.thumbnails.resize(160, _this6.player.video.videoHeight / _this6.player.video.videoWidth * 160, _this6.player.template.barWrap.offsetWidth);
                });
            }
        },
        {
            key: 'initPlayedBar',
            value: function initPlayedBar() {
                var _this7 = this;
                var allPanel = document.querySelectorAll('.mfunsPlayer-controller-panel-mask');
                var allTip = document.querySelectorAll('.mfunsPlayer-controller-tip');
                var showTip = function showTip(e) {
                    var px = _this7.player.template.barWrap.getBoundingClientRect().left;
                    var tx = (e.clientX || e.changedTouches[0].clientX) - px;
                    var tw = _this7.player.template.barTime.offsetWidth;
                    var time = _this7.player.video.duration * (tx / _this7.player.template.barWrap.offsetWidth);
                    if (tx < 0 || tx > _this7.player.template.barWrap.offsetWidth) {
                        return;
                    }
                    if (_this7.thumbnails.isShow) {
                        if (tx >= 80 && tx <= _this7.player.template.barWrap.offsetWidth - 80) {
                            _this7.player.template.barTime.classList.remove('thumbLimit');
                            _this7.player.template.barTime.style.left = ''.concat(tx - (time >= 3600 ? 25 : 20), 'px');
                        } else if (tx < 80) {
                            _this7.player.template.barTime.classList.add('thumbLimit');
                            _this7.player.template.barTime.style.left = ''.concat(80 - tw / 2, 'px');
                        } else if (tx > _this7.player.template.barWrap.offsetWidth - 80) {
                            _this7.player.template.barTime.classList.add('thumbLimit');
                            _this7.player.template.barTime.style.left = ''.concat(_this7.player.template.barWrap.offsetWidth - 80 - tw / 2, 'px');
                        }
                    } else {
                        _this7.player.template.barTime.style.left = ''.concat(tx - (time >= 3600 ? 25 : 20), 'px');
                    }
                    _this7.player.template.barMark.style.left = ''.concat(tx, 'px');
                    _this7.player.template.barTime.innerText = utils.secondToTime(time);
                    _this7.player.template.barMark.classList.remove('hidden');
                    _this7.player.template.barTime.classList.remove('hidden');
                    _this7.player.template.thumb.classList.remove('hidden');
                    _this7.thumbnails && _this7.thumbnails.show();
                    _this7.thumbnails && _this7.thumbnails.move(tx);
                };
                var hideTip = function hideTip() {
                    _this7.thumbnails && _this7.thumbnails.hide();
                    _this7.player.template.barTime.classList.add('hidden');
                    _this7.player.template.barMark.classList.add('hidden');
                    _this7.player.template.thumb.classList.add('hidden');
                };
                var thumbMove = function thumbMove(e) {
                    var _this7$player, _this7$player$highEne;
                    _this7.isControl = true;
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - utils.getBoundingClientRectViewLeft(_this7.player.template.barWrap)) / _this7.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    [].concat(_toConsumableArray(allPanel), _toConsumableArray(allTip)).forEach(function (el) {
                        el.classList.add('hide');
                    });
                    _this7.barLeave && showTip(e);
                    _this7.player.bar.set('played', percentage, 'width');
                    (_this7$player = _this7.player) === null || _this7$player === void 0 ? void 0 : (_this7$player$highEne = _this7$player.highEnergy) === null || _this7$player$highEne === void 0 ? void 0 : _this7$player$highEne.update(percentage);
                    _this7.player.template.barTime.innerHTML = utils.secondToTime(percentage * _this7.player.video.duration);
                    _this7.player.template.currentTime.innerHTML = utils.secondToTime(percentage * _this7.player.video.duration);
                };
                var thumbUp = function thumbUp(e) {
                    _this7.player.unableTimeupdate = false;
                    document.removeEventListener(utils.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(utils.nameMap.dragMove, thumbMove);
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - utils.getBoundingClientRectViewLeft(_this7.player.template.barWrap)) / _this7.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    [].concat(_toConsumableArray(allPanel), _toConsumableArray(allTip)).forEach(function (el) {
                        el.classList.remove('hide');
                    });
                    _this7.barLeave && hideTip();
                    _this7.player.template.currentTime.innerHTML = utils.secondToTime(percentage * _this7.player.video.duration);
                    _this7.player.bar.set('played', percentage, 'width');
                    _this7.player.seek(_this7.player.bar.get('played') * _this7.player.video.duration);
                    setTimeout(function () {
                        if (_this7.controlLeaved)
                            _this7.isControl = false;
                    }, 50);
                };
                this.player.template.barWrap.addEventListener(utils.nameMap.dragStart, function () {
                    document.addEventListener(utils.nameMap.dragMove, thumbMove);
                    document.addEventListener(utils.nameMap.dragEnd, thumbUp);
                    _this7.player.unableTimeupdate = true;
                });
                this.player.template.barWrap.addEventListener(utils.nameMap.dragMove, function (e) {
                    if (_this7.player.video.duration) {
                        showTip(e);
                        window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                    }
                });
                this.player.template.barWrap.addEventListener(utils.nameMap.dragEnd, function () {
                    _this7.player.unableTimeupdate = false;
                    _this7.thumbnails && _this7.thumbnails.hide();
                });
                this.player.template.barWrap.addEventListener('mouseenter', function () {
                    _this7.barLeave = false;
                    if (_this7.player.video.duration) {
                        _this7.thumbnails && _this7.thumbnails.show();
                        _this7.player.template.barTime.classList.remove('hidden');
                        _this7.player.template.barMark.classList.remove('hidden');
                        _this7.player.template.thumb.classList.remove('hidden');
                    }
                });
                this.player.template.barWrap.addEventListener('mouseleave', function () {
                    _this7.barLeave = true;
                    if (_this7.player.video.duration) {
                        _this7.thumbnails && _this7.thumbnails.hide();
                        _this7.thumbnails && _this7.player.template.barTime.classList.remove('thumbLimit');
                        _this7.player.template.barTime.classList.add('hidden');
                        _this7.player.template.barMark.classList.add('hidden');
                        _this7.player.template.thumb.classList.add('hidden');
                    }
                });
            }
        },
        {
            key: 'initTimeLabel',
            value: function initTimeLabel() {
                var _this8 = this;
                this.player.template.time_label.addEventListener('click', function () {
                    _this8.player.template.controllerTime.classList.add('inputting');
                    _this8.player.template.time_input.value = utils.secondToTime(_this8.player.video.currentTime);
                    _this8.player.template.time_input.focus();
                    _this8.isControl = true;
                });
                this.player.template.time_input.addEventListener('blur', function () {
                    var inputVal = _this8.player.template.time_input.value;
                    _this8.player.template.controllerTime.classList.remove('inputting');
                    if (/([0-9]?[0-9]?:?)([0-5]?[0-9]):([0-5][0-9])$/i.test(inputVal) && _this8.timeEdited) {
                        _this8.player.seek(utils.textToSecond(inputVal));
                    }
                    _this8.timeEdit = false;
                    _this8.isControl = false;
                });
                this.player.template.time_input.addEventListener('keydown', function (event) {
                    _this8.timeEdited = true;
                    var e = event || window.event;
                    if (e.keyCode == 13) {
                        _this8.player.template.video.currentTime = utils.textToSecond(_this8.player.template.time_input.value);
                        _this8.player.template.controllerTime.classList.remove('inputting');
                        _this8.player.template.time_input.value = '';
                    }
                    if (e.keyCode == 27) {
                        _this8.player.template.controllerTime.classList.remove('inputting');
                        _this8.player.template.time_input.value = '';
                    }
                });
            }
        },
        {
            key: 'initFullButton',
            value: function initFullButton() {
                var _this9 = this;
                this.player.template.fullscreen_btn.addEventListener('click', function () {
                    _this9.player.fullScreen.toggle('browser');
                    _this9.player.resize();
                });
                this.player.template.webfull_btn.addEventListener('click', function () {
                    _this9.player.fullScreen.toggle('web');
                    _this9.player.resize();
                });
            }
        },
        {
            key: 'initPagelistButton',
            value: function initPagelistButton() {
                var _this10 = this;
                this.player.template.pagelist.addEventListener('wheel', function (e) {
                    e.stopPropagation();
                });
                this.player.template.pageListLabel.addEventListener('mouseenter', function (e) {
                    var offsetScroll = _this10.player.template.pagelist.scrollHeight - _this10.player.template.pagelist.offsetHeight;
                    var scrollRate = offsetScroll * _this10.player.currentVideo / (_this10.player.options.video.length - 1);
                    _this10.player.template.pagelist.scrollTo(0, scrollRate);
                });
                var _loop = function _loop(i) {
                    _this10.player.template.pagelistItem[i].addEventListener('click', function (event) {
                        window.event ? window.event.cancelBubble = true : event.stopPropagation();
                        _this10.player.switchVideo(i);
                    });
                };
                for (var i = 0; i < this.player.template.pagelistItem.length; i++) {
                    _loop(i);
                }
                this.player.template.next_btn.addEventListener('click', function () {
                    var nextVideo = _this10.player.currentVideo + 1;
                    _this10.player.switchVideo(nextVideo);
                });
                this.player.template.prev_btn.addEventListener('click', function () {
                    var prevVideo = _this10.player.currentVideo - 1;
                    _this10.player.switchVideo(prevVideo);
                });
            }
        },
        {
            key: 'initSpeedButton',
            value: function initSpeedButton() {
                var _this11 = this;
                var _loop2 = function _loop2(i) {
                    _this11.player.template.speedItem[i].addEventListener('click', function (event) {
                        window.event ? window.event.cancelBubble = true : event.stopPropagation();
                        var currentSpeed = _this11.player.template.speedItem[i].dataset.speed;
                        _this11.player.speed(currentSpeed);
                        _this11.template.speedItem[i].classList.add('focus');
                        _this11.template.speedInfo.innerHTML = currentSpeed !== '1.0' ? currentSpeed + 'x' : '倍速';
                        _this11.template.speedItem.forEach(function (element, index) {
                            if (index !== i) {
                                element.classList.remove('focus');
                            }
                        });
                    });
                };
                for (var i = 0; i < this.player.template.speedItem.length; i++) {
                    _loop2(i);
                }
            }
        },
        {
            key: 'repeatTrigger',
            value: function repeatTrigger(loop) {
                this.player.template.repeat_btn.classList[''.concat(loop ? 'add' : 'remove')]('button-repeat');
                this.player.template.repeat_tip.innerText = loop ? '关闭洗脑循环' : '开启洗脑循环';
            }
        },
        {
            key: 'initRepeatButton',
            value: function initRepeatButton() {
                var _this12 = this;
                this.repeatTrigger(false);
                this.player.template.repeat_btn.addEventListener('click', function () {
                    _this12.video.loop = !_this12.video.loop;
                    _this12.repeatTrigger(_this12.video.loop);
                });
            }
        },
        {
            key: 'initVolumeButton',
            value: function initVolumeButton() {
                var _this13 = this;
                var THIS = this;
                var control;
                this.components.volumeSlider = new Slider_vertical(this.template.volumeBar, 0, 100, 1, this.player.options.volume * 100, {
                    start: function start() {
                        _this13.isControl = true;
                        _this13.template.volumeMask.classList.add('show');
                    },
                    change: function change(value) {
                        _this13.template.volumeNum.innerText = Math.round(value);
                        if (value == 0) {
                            _this13.player.template.volumeIcon.classList.add('button-volume-off');
                        } else {
                            _this13.player.template.volumeIcon.classList.remove('button-volume-off');
                        }
                    },
                    update: function update(value, controlFlag) {
                        _this13.isControl = controlFlag;
                        console.log(value);
                        _this13.player.volume(value * 0.01, true);
                    },
                    end: function end() {
                        setTimeout(function () {
                            _this13.isControl = false;
                        }, 50);
                        _this13.player.template.volumeMask.classList.remove('show');
                    }
                });
                this.player.template.volumeIcon.addEventListener('click', function (event) {
                    _this13.player.mute(!_this13.player.video.muted);
                    _this13.player.events && _this13.player.events.trigger('setPlayer', {
                        key: 'muted',
                        value: !_this13.player.video.muted
                    });
                });
            }
        },
        {
            key: 'initSettingsButton',
            value: function initSettingsButton() {
                var _this14 = this;
                var THIS = this;
                this.components.videoScalePicker = new Picker(this.template.video_scale_picker, 'auto', {
                    pick: function pick(value, nonotice) {
                        if (value == 'auto') {
                            THIS.videoScale = false;
                        } else {
                            value.replace(/^([0-9]+)-([0-9]+)$/, function (match, w, h) {
                                if (match) {
                                    THIS.videoScale = [
                                        Number(w),
                                        Number(h)
                                    ];
                                }
                            });
                        }
                        THIS.player.resize();
                    }
                });
                this.components.videoNextpageSwitch = new Switch(this.template.video_nextpage_switch, THIS.player.autoSwitch, {
                    on: function on(nonotice) {
                        THIS.player.autoSwitch = true;
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已开启分P连播');
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'autoSwitch',
                            value: true
                        });
                    },
                    off: function off(nonotice) {
                        THIS.player.autoSwitch = false;
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已关闭分P连播');
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'autoSwitch',
                            value: false
                        });
                    }
                });
                this.components.videoAutoplaySwitch = new Switch(this.template.video_autoplay_switch, THIS.player.autoPlay, {
                    on: function on(nonotice) {
                        THIS.player.autoPlay = true;
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已开启自动播放');
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'autoPlay',
                            value: true
                        });
                    },
                    off: function off(nonotice) {
                        THIS.player.autoPlay = false;
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已关闭自动播放');
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'autoPlay',
                            value: false
                        });
                    }
                });
                this.components.videoAutoSkipSwitch = new Switch(this.template.video_autoSkip_switch, THIS.player.autoSkip, {
                    on: function on(nonotice) {
                        THIS.player.autoSkip = true;
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'autoSkip',
                            value: true
                        });
                    },
                    off: function off(nonotice) {
                        THIS.player.autoSkip = false;
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'autoSkip',
                            value: false
                        });
                    }
                });
                this.components.videoSmallWindowSwitch = new Switch(this.template.video_smallWindow_switch, THIS.player.options.smallWindow, {
                    on: function on(nonotice) {
                        window.addEventListener('scroll', _this14.watchPlayerScroll);
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'smallWindow',
                            value: true
                        });
                    },
                    off: function off(nonotice) {
                        window.removeEventListener('scroll', _this14.watchPlayerScroll);
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'smallWindow',
                            value: false
                        });
                    }
                });
                this.components.videoBorderhiddenSwitch = new Switch(this.template.video_borderhidden_switch, !this.player.options.blackBorder, {
                    on: function on(nonotice) {
                        THIS.player.template.buildVideo(false);
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已隐藏黑边');
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'blackBorder',
                            value: false
                        });
                    },
                    off: function off(nonotice) {
                        THIS.player.template.buildVideo(true);
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已显示黑边');
                        THIS.player.events && THIS.player.events.trigger('setPlayer', {
                            key: 'blackBorder',
                            value: true
                        });
                    }
                });
                this.components.videoDarkmodeSwitch = new Switch(this.template.video_darkmode_switch, false, {
                    on: function on(nonotice) {
                        var _THIS$player$template, _THIS$player$template2;
                        document.body.classList.add('player-mode-blackmask');
                        (_THIS$player$template = THIS.player.template.footBar) === null || _THIS$player$template === void 0 ? void 0 : (_THIS$player$template2 = _THIS$player$template.classList) === null || _THIS$player$template2 === void 0 ? void 0 : _THIS$player$template2.add('darkmode');
                        THIS.player.container.classList.add('mfunsPlayer-darkmode');
                        document.body.appendChild(THIS.mask);
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已开启关灯模式');
                    },
                    off: function off(nonotice) {
                        if (_toConsumableArray(document.body.childNodes).includes(THIS.mask)) {
                            var _THIS$player$template3, _THIS$player$template4;
                            (_THIS$player$template3 = THIS.player.template.footBar) === null || _THIS$player$template3 === void 0 ? void 0 : (_THIS$player$template4 = _THIS$player$template3.classList) === null || _THIS$player$template4 === void 0 ? void 0 : _THIS$player$template4.remove('darkmode');
                            THIS.player.container.classList.remove('mfunsPlayer-darkmode');
                            document.body.classList.remove('player-mode-blackmask');
                            document.body.removeChild(THIS.mask);
                        }
                        THIS.player.videoLoaded && !nonotice && THIS.player.notice('已关闭关灯模式');
                    }
                });
                this.components.videoMirrorSwitch = new Switch(this.template.video_mirror_switch, false, {
                    on: function on(nonotice) {
                        _this14.player.template.videoMask.classList.add('mirror');
                        _this14.player.videoLoaded && !nonotice && _this14.player.notice('已开启镜像画面');
                    },
                    off: function off(nonotice) {
                        _this14.player.template.videoMask.classList.remove('mirror');
                        _this14.player.videoLoaded && !nonotice && _this14.player.notice('已关闭镜像画面');
                    }
                });
            }
        },
        {
            key: 'initDanmakuButton',
            value: function initDanmakuButton() {
                var _this15 = this;
                this.player.template.danmaku_btn.addEventListener('click', function () {
                    if (!_this15.player.danmaku.showing) {
                        _this15.player.danmaku.show();
                    } else {
                        _this15.player.danmaku.hide();
                    }
                });
                this.player.on('danmaku_show', function () {
                    _this15.player.template.danmaku_btn.classList.add('open');
                    _this15.player.template.danmaku_btn.classList.remove('close');
                });
                this.player.on('danmaku_hide', function () {
                    _this15.player.template.danmaku_btn.classList.add('close');
                    _this15.player.template.danmaku_btn.classList.remove('open');
                });
            }
        },
        {
            key: 'initDanmakuEmit',
            value: function initDanmakuEmit() {
                var _this16 = this;
                this.player.template.danmakuEmit.addEventListener('click', function () {
                    var danmakuText = _this16.player.template.danmakuText.value;
                    if (danmakuText.trim()) {
                        _this16.player.danmaku.send({
                            size: _this16.danmakuFontsize,
                            type: _this16.danmakuType,
                            color: _this16.danmakuColor,
                            text: danmakuText
                        });
                        _this16.player.template.danmakuText.value = '';
                        _this16.player.template.danmakuText.blur();
                    }
                });
            }
        },
        {
            key: 'initDanmakuSettingsButton',
            value: function initDanmakuSettingsButton() {
                var THIS = this;
                var shields = this.player.options.danmaku.shields;
                var opacity = this.player.options.danmaku.opacity;
                var showArea = this.player.options.danmaku.limitArea;
                var danmakuSize = this.player.options.danmaku.fontScale;
                var danmakuSpeed = this.player.options.danmaku.speed;
                this.components.danmakuFilterPicker = new MultiPicker(this.template.danmaku_filter_picker, shields, {
                    created: function created(thisArg) {
                    },
                    pick: function pick(value, nonotice) {
                        console.log('屏蔽弹幕类型\uFF1A'.concat(value));
                        THIS.player.danmaku && THIS.player.danmaku.shield(value, true);
                    },
                    unpick: function unpick(value) {
                        console.log('取消屏蔽弹幕类型\uFF1A'.concat(value));
                        THIS.player.danmaku && THIS.player.danmaku.shield(value, false);
                    },
                    update: function update(value) {
                    }
                });
                this.components.danmakuOpacitySlider = new Slider(this.template.danmaku_opacity_slider, 10, 100, 1, opacity * 100, {
                    start: function start() {
                        THIS.isControl = true;
                        THIS.template.danmakuSettings_panel.classList.add('show');
                    },
                    update: function update(value, flag) {
                        THIS.isControl = flag;
                        THIS.player.danmaku && THIS.player.danmaku.opacity(value / 100);
                    },
                    change: function change(value) {
                        THIS.template.danmaku_opacity_value.innerText = ''.concat(value, '%');
                    },
                    end: function end() {
                        setTimeout(function () {
                            THIS.isControl = false;
                        }, 50);
                        THIS.player.template.danmakuSettings_panel.classList.remove('show');
                    }
                });
                this.components.danmakuShowareaSlider = new Slider(this.template.danmaku_showarea_slider, 20, 100, 20, showArea * 20, {
                    start: function start() {
                        console.log('--------');
                        THIS.isControl = true;
                        THIS.template.danmakuSettings_panel.classList.add('show');
                    },
                    update: function update(value, flag) {
                        THIS.isControl = flag;
                    },
                    change: function change(value) {
                        THIS.template.danmaku_showarea_value.innerText = [
                            '1/4',
                            '半屏',
                            '3/4',
                            '不重叠',
                            '不限'
                        ][value / 20 - 1];
                        THIS.player.danmaku && THIS.player.danmaku.limitArea(value / 20);
                    },
                    end: function end() {
                        setTimeout(function () {
                            THIS.isControl = false;
                        }, 50);
                        THIS.player.template.danmakuSettings_panel.classList.remove('show');
                    }
                });
                this.components.danmakuSizeSlider = new Slider(this.template.danmaku_size_slider, 50, 150, 1, danmakuSize * 100, {
                    start: function start() {
                        THIS.isControl = true;
                        THIS.template.danmakuSettings_panel.classList.add('show');
                    },
                    update: function update(value, flag) {
                        THIS.isControl = flag;
                    },
                    change: function change(value) {
                        THIS.template.danmaku_size_value.innerText = value + '%';
                        THIS.player.danmaku && THIS.player.danmaku.size(value / 100);
                    },
                    end: function end() {
                        setTimeout(function () {
                            THIS.isControl = false;
                        }, 50);
                        THIS.player.template.danmakuSettings_panel.classList.remove('show');
                    }
                });
                this.components.danmakuSpeedSlider = new Slider(this.template.danmaku_speed_slider, 50, 150, 25, danmakuSpeed * 100, {
                    start: function start() {
                        console.log('--------');
                        THIS.isControl = true;
                        THIS.template.danmakuSettings_panel.classList.add('show');
                    },
                    update: function update(value, flag) {
                        THIS.isControl = flag;
                    },
                    change: function change(value) {
                        THIS.template.danmaku_speed_value.innerText = utils.number2danmakuSpeed(value / 100);
                        THIS.player.danmaku && THIS.player.danmaku.speed(value / 100);
                    },
                    end: function end() {
                        setTimeout(function () {
                            THIS.isControl = false;
                        }, 50);
                        THIS.player.template.danmakuSettings_panel.classList.remove('show');
                    }
                });
                this.components.danmakuCatchSwitch = new Switch(this.template.danmaku_catch_switch, this.player.options.danmaku.danmakuCatch, {
                    on: function on(nonotice) {
                        THIS.player.template.danmakuTipMask.style.display = '';
                        !nonotice && THIS.player.notice('已开启弹幕捕获模式');
                        THIS.player.events && THIS.player.events.trigger('setDanmaku', {
                            key: 'danmakuCatch',
                            value: true
                        });
                    },
                    off: function off(nonotice) {
                        THIS.player.template.danmakuTipMask.style.display = 'none';
                        !nonotice && THIS.player.notice('已关闭弹幕捕获模式');
                        THIS.player.events && THIS.player.events.trigger('setDanmaku', {
                            key: 'danmakuCatch',
                            value: false
                        });
                    }
                });
                this.components.danmakuKeepOutSubtitleSwitch = new Switch(this.template.danmaku_keep_out_subtitle_switch, this.player.options.danmaku.keepOutSubtitle, {
                    on: function on(nonotice) {
                        THIS.player.danmaku.limitArea('keepOutSubtitle');
                        !nonotice && THIS.player.notice('已开启防挡字幕');
                        THIS.player.events && THIS.player.events.trigger('setDanmaku', {
                            key: 'keepOutSubtitle',
                            value: true
                        });
                    },
                    off: function off(nonotice) {
                        THIS.player.danmaku && THIS.player.danmaku.limitArea('notKeepOutSubtitle');
                        !nonotice && THIS.player.notice('已关闭防挡字幕');
                        THIS.player.events && THIS.player.events.trigger('setDanmaku', {
                            key: 'keepOutSubtitle',
                            value: false
                        });
                    }
                });
            }
        },
        {
            key: 'initDanmakuStyleButton',
            value: function initDanmakuStyleButton() {
                var THIS = this;
                this.components.danmakuFontsizePicker = new Picker(this.template.danmaku_fontsize_picker, this.danmakuFontsize, {
                    pick: function pick(value) {
                        THIS.danmakuFontsize = value;
                    }
                });
                this.components.danmakuModePicker = new Picker(this.template.danmaku_mode_picker, this.danmakuType, {
                    pick: function pick(value) {
                        THIS.danmakuType = value;
                    }
                });
                this.components.danmakuColorPicker = new Picker(this.template.danmaku_color_picker, this.danmakuColor, {
                    pick: function pick(value) {
                        if (/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(value)) {
                            THIS.danmakuColor = utils.color2Number(value);
                            THIS.template.danmaku_color_input.value = value;
                            THIS.template.danmaku_color_preview.style['background-color'] = value;
                            if (value != value.toUpperCase()) {
                                THIS.components.danmakuColorPicker.change(value.toUpperCase());
                            }
                        }
                    }
                });
                this.template.danmaku_color_input.addEventListener('input', function () {
                    this.value = '#' + this.value.replace(/[^0-9A-Fa-f]/g, '').slice(0, 6);
                    THIS.components.danmakuColorPicker.pick(this.value);
                });
                this.template.danmaku_color_preview.addEventListener('click', function () {
                    THIS.components.danmakuColorPicker.pick(THIS.danmakuColor);
                });
            }
        },
        {
            key: 'initPictureInPicture',
            value: function initPictureInPicture() {
                var _this17 = this;
                if (this.player.template.pip_btn) {
                    this.player.template.pip_btn.addEventListener('click', function () {
                        if (!document.pictureInPictureElement) {
                            _this17.video.requestPictureInPicture()['catch'](function (error) {
                                console.log(error, 'Video failed to enter Picture-in-Picture mode.');
                            });
                        } else {
                            document.exitPictureInPicture()['catch'](function (error) {
                                console.log(error, 'Video failed to leave Picture-in-Picture mode.');
                            });
                        }
                    });
                }
                this.video.addEventListener('enterpictureinpicture', function () {
                    _this17.player.template.pip_btn.classList.add('button-picture-in-picture');
                });
                this.video.addEventListener('leavepictureinpicture', function () {
                    _this17.player.template.pip_btn.classList.remove('button-picture-in-picture');
                });
            }
        },
        {
            key: 'widescreenTrigger',
            value: function widescreenTrigger(widescreen) {
            }
        },
        {
            key: 'initWidescreenButton',
            value: function initWidescreenButton() {
                var _this18 = this;
                this.template.widescreen_btn.addEventListener('click', function () {
                    _this18.player.widescreen = !_this18.player.widescreen;
                    var widescreen = _this18.player.widescreen;
                    _this18.player.template.widescreen_btn.classList[''.concat(widescreen ? 'add' : 'remove')]('exit');
                    _this18.player.events.trigger(widescreen ? 'widescreen' : 'widescreen_cancel');
                    console.log(widescreen ? '进入宽屏模式' : '退出宽屏模式');
                    _this18.player.template.widescreen_tip.innerText = widescreen ? '退出宽屏' : '宽屏模式';
                });
            }
        },
        {
            key: 'setAutoHide',
            value: function setAutoHide() {
                var _this19 = this;
                var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
                this.show();
                clearTimeout(this.autoHideTimer);
                this.autoHideTimer = setTimeout(function () {
                    if (_this19.video.played.length && !_this19.isControl) {
                        _this19.hide();
                    }
                }, delay);
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.container.classList.remove('mfunsPlayer-hide-controller');
                this.template.controllerMask.style.cursor = 'default';
                this.template.controllerMask.classList.remove('hide');
                this.template.headBar.classList.remove('hide');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.container.classList.add('mfunsPlayer-hide-controller');
                this.template.danmakuTip.classList.remove('show');
                this.template.controllerMask.style.cursor = 'none';
                this.template.controllerMask.classList.add('hide');
                this.template.headBar.classList.add('hide');
                this.timeEdited = false;
                this.player.template.controllerTime.classList.remove('inputting');
            }
        },
        {
            key: 'isShow',
            value: function isShow() {
                return !this.player.container.classList.contains('mfunsPlayer-controller-hide');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.isShow()) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                clearTimeout(this.autoHideTimer);
            }
        }
    ]);
    return Controller;
}();
export default Controller;